import React from 'react';

const Games = () => {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      {/* Hero Section */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px',
        padding: '60px 20px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        borderRadius: '20px'
      }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '25px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          🎯 Fun Name Games & Party Activities
        </h1>
        <p style={{
          fontSize: '22px',
          marginBottom: '35px',
          opacity: '0.95',
          maxWidth: '900px',
          margin: '0 auto 35px'
        }}>
          Turn any gathering into an exciting event with our <strong>party spinner name game</strong>. Perfect for icebreakers, team building, and entertainment!
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#764ba2',
            padding: '18px 40px',
            borderRadius: '35px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '20px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.3)'
          }}
        >
          Start Fun Games Now 🎉
        </a>
      </div>

      {/* Game Categories */}
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '15px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎪 Popular Name Game Categories
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            padding: '30px',
            borderRadius: '15px',
            backgroundColor: '#fff3e0',
            border: '2px solid #ffcc80'
          }}>
            <div style={{
              fontSize: '60px',
              textAlign: 'center',
              marginBottom: '20px'
            }}>🧊</div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#e65100',
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              Icebreaker Games
            </h3>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '15px' }}>
              Break the ice at parties and meetings with our <strong>name picker for games</strong> that gets everyone involved.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                "Two Truths and a Lie" selector
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                "Share a Fun Fact" randomizer
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                "Speed Introductions" spinner
              </li>
            </ul>
          </div>

          <div style={{
            padding: '30px',
            borderRadius: '15px',
            backgroundColor: '#e8f5e8',
            border: '2px solid #a5d6a7'
          }}>
            <div style={{
              fontSize: '60px',
              textAlign: 'center',
              marginBottom: '20px'
            }}>🏃</div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#2e7d32',
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              Active Party Games
            </h3>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '15px' }}>
              Get everyone moving with energetic games using our <strong>random game wheel</strong> for active fun.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Charades team captain picker
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Dance-off battle selector
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Scavenger hunt team leader
              </li>
            </ul>
          </div>

          <div style={{
            padding: '30px',
            borderRadius: '15px',
            backgroundColor: '#f3e5f5',
            border: '2px solid #ce93d8'
          }}>
            <div style={{
              fontSize: '60px',
              textAlign: 'center',
              marginBottom: '20px'
            }}>🧠</div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#7b1fa2',
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              Trivia & Quiz Games
            </h3>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '15px' }}>
              Make quiz nights fair and exciting with our <strong>trivia name spinner</strong> for question selection.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Quiz team formation
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Bonus round participant picker
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Lightning round selector
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Specific Game Ideas */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '50px',
        borderRadius: '15px',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎮 Ready-to-Play Game Ideas
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              🎭 "Who Am I?" Challenge
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '16px' }}>
              Use our <strong>spin the wheel for names</strong> to select who gets the mystery identity card.
            </p>
            <div style={{
              backgroundColor: '#f0f8ff',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '15px'
            }}>
              <strong>How to Play:</strong>
              <ol style={{ marginTop: '10px', paddingLeft: '20px' }}>
                <li>Add all player names to the wheel</li>
                <li>Spin to select the "mystery person"</li>
                <li>They get a famous person/character card</li>
                <li>Others ask yes/no questions to guess</li>
              </ol>
            </div>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Perfect for: Birthday parties, family gatherings, team events
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              🎤 Karaoke Roulette
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '16px' }}>
              Let our <strong>random name selector</strong> decide who performs next at your karaoke party.
            </p>
            <div style={{
              backgroundColor: '#f0f8ff',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '15px'
            }}>
              <strong>How to Play:</strong>
              <ol style={{ marginTop: '10px', paddingLeft: '20px' }}>
                <li>Enter all party guests' names</li>
                <li>Spin to choose the next performer</li>
                <li>Selected person picks their song</li>
                <li>Remove name for next round or keep for multiple performances</li>
              </ol>
            </div>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Perfect for: House parties, celebrations, corporate events
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              🍕 Decision Maker Games
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '16px' }}>
              Turn tough decisions into fun games with our <strong>decision spinner tool</strong>.
            </p>
            <div style={{
              backgroundColor: '#f0f8ff',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '15px'
            }}>
              <strong>How to Play:</strong>
              <ol style={{ marginTop: '10px', paddingLeft: '20px' }}>
                <li>Add options instead of names (pizza toppings, movie choices, etc.)</li>
                <li>Let the wheel decide for the group</li>
                <li>No arguments, just fun random selection</li>
                <li>Great for settling friendly debates</li>
              </ol>
            </div>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Perfect for: Friend groups, family decisions, date nights
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              📚 Story Building Game
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '16px' }}>
              Create collaborative stories using our <strong>name picker wheel</strong> to select storytellers.
            </p>
            <div style={{
              backgroundColor: '#f0f8ff',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '15px'
            }}>
              <strong>How to Play:</strong>
              <ol style={{ marginTop: '10px', paddingLeft: '20px' }}>
                <li>Start with a story opening sentence</li>
                <li>Spin to select next contributor</li>
                <li>Each person adds 2-3 sentences</li>
                <li>Continue until story reaches conclusion</li>
              </ol>
            </div>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Perfect for: Creative writing groups, classroom activities, camps
            </p>
          </div>
        </div>
      </div>

      {/* Benefits for Different Groups */}
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '15px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎊 Perfect for Every Occasion
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            textAlign: 'center',
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#fff3e0',
            border: '2px solid #ffcc80'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px'
            }}>🎂</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#e65100',
              marginBottom: '15px'
            }}>
              Birthday Parties
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Make birthdays unforgettable with our <strong>birthday party name games</strong> that get everyone involved and laughing.
            </p>
          </div>

          <div style={{
            textAlign: 'center',
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#e8f5e8',
            border: '2px solid #a5d6a7'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px'
            }}>🏢</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#2e7d32',
              marginBottom: '15px'
            }}>
              Team Building
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Break down barriers and build connections with our <strong>corporate team building games</strong> and icebreakers.
            </p>
          </div>

          <div style={{
            textAlign: 'center',
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#f3e5f5',
            border: '2px solid #ce93d8'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px'
            }}>👨‍👩‍👧‍👦</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#7b1fa2',
              marginBottom: '15px'
            }}>
              Family Gatherings
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Bring generations together with our <strong>family-friendly name games</strong> that work for all ages.
            </p>
          </div>

          <div style={{
            textAlign: 'center',
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#e3f2fd',
            border: '2px solid #90caf9'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px'
            }}>🏫</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#1565c0',
              marginBottom: '15px'
            }}>
              Educational Events
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Make learning fun with our <strong>educational name games</strong> that encourage participation and engagement.
            </p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        textAlign: 'center',
        padding: '60px 30px',
        background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%)',
        borderRadius: '20px'
      }}>
        <h2 style={{
          fontSize: '42px',
          fontWeight: 'bold',
          marginBottom: '25px',
          color: '#333'
        }}>
          Ready to Create Unforgettable Memories? 🎉
        </h2>
        <p style={{
          fontSize: '22px',
          marginBottom: '35px',
          color: '#444',
          maxWidth: '700px',
          margin: '0 auto 35px'
        }}>
          Turn any gathering into an epic celebration with our <strong>free party name games</strong>. No setup required - just pure fun!
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: '#667eea',
            color: 'white',
            padding: '20px 45px',
            borderRadius: '35px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '22px',
            boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)'
          }}
        >
          Start Playing Fun Games Now →
        </a>
        <div style={{
          marginTop: '25px',
          fontSize: '18px',
          color: '#555'
        }}>
          Free forever • Works on all devices • No downloads needed
        </div>
      </div>
    </div>
  );
};

export default Games;